import { useAdminVenueStore } from '../../share/store/adminVenueStore';
import { useStandardAlertStore } from '../../../shared/store/portal/alertStore';
import { scrollToChangedElement } from '../../../shared/hooks/useUnsavedChanges';

export const runAfterUnsavedVenueCheck = (action: () => void) => {
  if (!useAdminVenueStore.getState().hasChanged) {
    action();
    return;
  }

  setTimeout(scrollToChangedElement, 100);
  useStandardAlertStore.getState().setUnchangedAlert(action);
};

export const runAfterVenueListContextChange = (action: () => void) => {
  if (useAdminVenueStore.getState().multiSelectedVenueIds.length < 2) {
    action();
    return;
  }
  runAfterUnsavedVenueCheck(() => {
    useAdminVenueStore.getState().clearVenueSelection();
    action();
  });
};
